import React from "react";
import { LazyLoadImages } from "@quintype/components";
import { SpecialPage as SpecialPageBase } from "../components/pages/special-page";
import { TaxPage as TaxPageBase } from "../components/pages/tax";
import { ElectionPage as ElectionPageBase } from "../components/pages/election-page";
import { FlamesPage as FlamesPageBase } from "../components/pages/flames";
import { AksPage as AksPageBase } from "../components/pages/aks";
import { ConstituencyPage as ConstituencyPageBase } from "../components/pages/constituency";
import { LoksabhaDetailPage as LoksabhaDetailPageBase } from "../components/pages/lok-sabha-candidate-page";
import { SeriesLandingPage as SeriesLandingPagebase } from "../components/pages/vikatan-series-bundle";
import { ShortsPage as ShortsPageBase } from "../components/pages/shorts-page";
import { CandidatePage as CandidatePageBase } from "../components/pages/candidate";
import { CandidateResultPage as CandidateResultPageBase } from "../components/pages/candidate-result";
import { ForyouPage as ForyouPageBase } from "../components/pages/foryou";
import { RecommendPage as RecommendPageBase } from "../components/pages/recommend-page";
import { SiteMapPage as SiteMapPageBase } from "../components/pages/site-map/index";
import { SpecificYearPage as SpecificYearPageBase } from "../components/pages/site-map/year";
import { SpecificMonthPage as SpecificMonthPageBase } from "../components/pages/site-map/month";
import { SpecificDateStories as SpecificDateStoriesBase } from "../components/pages/site-map/date";
import { ShortNewsPage as ShortNewsPageBase } from "../components/pages/short-news-page";
import { GurupeyarchiStaticPage as GurupeyarchiStaticPageBase } from "../components/pages/gurupeyachi-static";
import { RaaguKedhuStaticPage as RaaguKedhuStaticPageBase } from "../components/pages/raagu-kedhu-static";
import { APYCalculatorPage as APYCalculatorPageBase } from "../components/pages/apy-calculator";
import { GoogleSearchPage as GoogleSearchBase } from "../components/pages/google-search";
import HeaderAdUnit from "../components/atoms/header-ad-unit";
import { PDFPage as PDFPageBase } from "../components/pages/pdf-preview";
import { AudioPage as AudioPageBase } from "../components/pages/audio-page";
import { LoksabhaCandidatesPage as LoksabhaCandidatesPageBase } from "../components/pages/loksabha-candidates-2024";
import { ThirukuralPage as ThirukuralPageBase } from "../components/pages/thirukural";
import { ThirukuralExplanationPage as ThirukuralExplanationPageBase } from "../components/pages/thirukural/explanation";
import { TNElectionPage as TNElectionPageBase } from "../components/pages/tn-election-home-2026";
import { ConstituencyElectionPage as ConstituencyElectionPageBase } from "../components/pages/Constituency-election-2026";

function wrapLazyLoadImages(Template, adShow = true) {
  const ImageLazyLoadedComponent = props => {
    return (
      <React.Fragment>
        {adShow && <HeaderAdUnit />}
        <LazyLoadImages margin={"150px"}>
          <Template {...props} />
        </LazyLoadImages>
      </React.Fragment>
    );
  };
  ImageLazyLoadedComponent.displayName = `WrapLazyLoadImages(${Template.name})`;
  return ImageLazyLoadedComponent;
}

export const TaxPage = wrapLazyLoadImages(TaxPageBase);
export const ElectionPage = wrapLazyLoadImages(ElectionPageBase);
export const FlamesPage = wrapLazyLoadImages(FlamesPageBase);
export const AksPage = wrapLazyLoadImages(AksPageBase);
export const ConstituencyPage = wrapLazyLoadImages(ConstituencyPageBase);
export const LoksabhaDetailPage = wrapLazyLoadImages(LoksabhaDetailPageBase);
export const SeriesLandingPage = wrapLazyLoadImages(SeriesLandingPagebase);
export const SpecialPage = wrapLazyLoadImages(SpecialPageBase);
export const ShortsPage = wrapLazyLoadImages(ShortsPageBase);
export const CandidatePage = wrapLazyLoadImages(CandidatePageBase);
export const CandidateResultPage = wrapLazyLoadImages(CandidateResultPageBase);
export const ForyouPage = wrapLazyLoadImages(ForyouPageBase);
export const SiteMapPage = wrapLazyLoadImages(SiteMapPageBase);
export const SpecificYearPage = wrapLazyLoadImages(SpecificYearPageBase);
export const SpecificMonthPage = wrapLazyLoadImages(SpecificMonthPageBase);
export const SpecificDateStories = wrapLazyLoadImages(SpecificDateStoriesBase);
export const ShortNewsPage = wrapLazyLoadImages(ShortNewsPageBase, false);
export const GurupeyarchiStaticPage = wrapLazyLoadImages(GurupeyarchiStaticPageBase);
export const RaaguKedhuStaticPage = wrapLazyLoadImages(RaaguKedhuStaticPageBase);
export const APYCalculatorPage = wrapLazyLoadImages(APYCalculatorPageBase);
export const RecommendPage = wrapLazyLoadImages(RecommendPageBase);
export const GoogleSearchPage = wrapLazyLoadImages(GoogleSearchBase);
export const PDFPage = wrapLazyLoadImages(PDFPageBase, false);
export const AudioPage = wrapLazyLoadImages(AudioPageBase, false);
export const LoksabhaCandidatesPage = wrapLazyLoadImages(LoksabhaCandidatesPageBase);
export const ThirukuralPage = wrapLazyLoadImages(ThirukuralPageBase);
export const ThirukuralExplanationPage = wrapLazyLoadImages(ThirukuralExplanationPageBase);
export const TNElectionPage = wrapLazyLoadImages(TNElectionPageBase, false);
export const ConstituencyElectionPage = wrapLazyLoadImages(ConstituencyElectionPageBase, false);
